import React from "react";
import { Hexagon } from "lucide-react";
import { cn } from "@/lib/utils";

export const BrandLogo = ({ size = "md", light = false, className }) => {
  const box = size === "lg" ? "h-12 w-12 rounded-xl" : "h-9 w-9 rounded-lg";
  const icon = size === "lg" ? "h-7 w-7" : "h-5 w-5";
  const num = size === "lg" ? "text-[13px]" : "text-[10px]";
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="brand-logo-mark">
      <span className={cn("relative flex items-center justify-center bg-primary text-primary-foreground", box)}>
        <Hexagon className={icon} strokeWidth={2.4} />
        <span className={cn("absolute font-bold font-mono", num)}>20</span>
      </span>
      <div className="text-left leading-none">
        <div className={cn("font-heading font-extrabold tracking-tight", size === "lg" ? "text-2xl" : "text-lg", light && "text-white")}>D20</div>
        <div className={cn("text-[10px] tracking-wide", light ? "text-white/50" : "text-muted-foreground")}>INVOICE AI</div>
      </div>
    </div>
  );
};
